module.exports = __webpack_public_path__ + "media/sword3.49f1e92e.wav";